module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-6.60a66372.png";